// src/redux/paymentStatusSlice.js

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { makeApiCall } from "../../makeAPICall";
import {
  PAYMENT_STATUS_CONTROLLER,
  PAYMENT_STATUS_PAGINATION_CONTROLLER,
} from "../../actionTypes";

export const getPaymentStatussWithPagination = createAsyncThunk(
  "paymentStatus/getPaymentStatussWithPagination",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "post",
        `/${PAYMENT_STATUS_PAGINATION_CONTROLLER}`,
        obj,
        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
export const savePaymentStatus = createAsyncThunk(
  "paymentStatus/savePaymentStatus",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "post",
        `/${PAYMENT_STATUS_CONTROLLER}`,
        obj,
        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
export const updatePaymentStatus = createAsyncThunk(
  "paymentStatus/updatePaymentStatus",
  async (obj, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "put",
        `/${PAYMENT_STATUS_CONTROLLER}/${obj.id}`,
        obj,
        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);

export const getPaymentStatuss = createAsyncThunk(
  "paymentStatus/getPaymentStatuss",
  async (id, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "get",
        `/${PAYMENT_STATUS_CONTROLLER}`,

        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
export const getPaymentStatus = createAsyncThunk(
  "paymentStatus/getPaymentStatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "get",
        `/${PAYMENT_STATUS_CONTROLLER}/${id}`,

        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
export const deletePaymentStatus = createAsyncThunk(
  "paymentStatus/deletePaymentStatus",
  async (id, { rejectWithValue }) => {
    try {
      const response = await makeApiCall(
        "delete",
        `/${PAYMENT_STATUS_CONTROLLER}/${id}`,
        {}
      );

      if (!response) {
        // Handle non-successful responses
        throw new Error("Date Fetching failed");
      }

      const data = await response;

      return data.data || null;
    } catch (error) {
      return rejectWithValue(error.message); // Pass the error message to the rejectWithValue payload
    }
  }
);
const paymentStatusSlice = createSlice({
  name: "paymentStatus",
  initialState: {
    paymentStatuss: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentStatussWithPagination.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentStatussWithPagination.fulfilled, (state, action) => {
        state.paymentStatuss = action.payload.data;
        state.loading = false;
        state.error = null;
      })
      .addCase(getPaymentStatussWithPagination.rejected, (state, action) => {
        state.paymentStatuss = [];
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(savePaymentStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(savePaymentStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(savePaymentStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPaymentStatuss.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentStatuss.fulfilled, (state, action) => {
        const data = action.payload.data;
        state.paymentStatuss =
          data &&
          data.length > 0 &&
          data.map((x) => {
            return {
              label: x.name,
              value: x.id,
            };
          });
        state.loading = false;
        state.error = null;
      })
      .addCase(getPaymentStatuss.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = paymentStatusSlice.actions;
export default paymentStatusSlice.reducer;
